import { isSectionGroupBlueprint } from '../validations';
export const translateBlueprintIdToNodeId = (blueprint) => {
    const blueprintIdToNodeId = {};
    Object.keys(blueprint.sectionGroupBlueprints).forEach((key) => {
        const sectionGroup = blueprint.sectionGroupBlueprints[key];
        if (!sectionGroup || !isSectionGroupBlueprint(sectionGroup)) {
            return;
        }
        const repeatableAnswerNodeId = sectionGroup.repeatable?.repeatableAnswerNodeId;
        if (repeatableAnswerNodeId) {
            blueprintIdToNodeId[sectionGroup.id] = repeatableAnswerNodeId;
        }
    });
    // We grab the first one we find, it does not matter, the linkedBlueprintsIds will propagate the answers.
    blueprint.sectionBlueprints.forEach((section) => {
        section.subsections.forEach((subsection) => {
            subsection.fieldGroups.forEach((fieldGroup) => {
                const repeatableAnswerNodeId = fieldGroup.repeatable?.repeatableAnswerNodeId;
                if (repeatableAnswerNodeId) {
                    blueprintIdToNodeId[fieldGroup.id] = repeatableAnswerNodeId;
                }
                fieldGroup.fields.forEach((field) => {
                    blueprintIdToNodeId[field.id] = field.answerNodeId;
                });
            });
        });
    });
    return blueprintIdToNodeId;
};
